import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Form, Formik } from 'formik'

import { Loading } from 'components/UI'
import BaseModal from '../BaseModal'
import { closeModal } from 'store/actions/modals'
import { EventSummaryList } from 'components/Schedule'
import { Button, Checkbox, Textarea } from 'components/Forms'
import useApi from 'components/Hooks/useApi'
import { Alert, Card } from 'ui'

import { t } from 'translations'

function ScheduleUnassignEmployeeModal({ ids }) {
  const dispatch = useDispatch()

  // Queries definition
  const { isLoading, isError: loadingEventsError, response, handleApi: loadEvents } = useApi({ method: 'POST', url: 'schedule/schedule/query' })

  const { handleApi: unassignEmployee, isError: cancelRequestError } = useApi({
    method: 'PUT',
    url: 'schedule/cancel'
  })

  // Load events
  useEffect(() => {
    ;(async () => {
      await loadEvents({ shiftIds: ids, showCancelledShift: true })
    })()
  }, [ids, loadEvents])

  const hasRecurrence = response?.some(event => event.rruleId)
  const hasPublished = response?.some(event => event.published)
  const events = response?.length && response.filter(event => event.employeeId)

  const onSubmit = async ({ sendCancellationEmails, cancellationComment, cancelFutureRecurrence }) => {
    await unassignEmployee({
      eventIds: events.map(({ _id }) => _id),
      sendCancellationEmails,
      cancelEmployee: true,
      cancellationComment,
      cancelFutureRecurrence
    })

    dispatch(closeModal())
  }

  if (isLoading) return <Loading />

  return (
    <BaseModal hideButtons title={`manager.schedule.UNASSIGN_EMPLOYEE_MODAL`}>
      {!!loadingEventsError || !!cancelRequestError ? (
        <Alert variant="warning" className="mt-2">
          {t('manager.schedule.UNASSIGN_EMPLOYEE_MODAL.ERROR_LOADING')}
        </Alert>
      ) : (
        <Formik
          enableReinitialize={true}
          initialValues={{ sendCancellationEmails: hasPublished, reason: '', cancellationComment: '', cancelFutureRecurrence: false }}
          onSubmit={onSubmit}
        >
          {({ isSubmitting, values }) => {
            return (
              <Form className="mt-2">
                <Alert variant="warning" className="my-2" show={!!values.sendCancellationEmails}>
                  {t('manager.schedule.SEND_CANCELLATION_NOTICE')}
                </Alert>
                <EventSummaryList events={events} />
                {hasPublished || hasRecurrence ? (
                  <Card>
                    <Card.Body className="bg-light mt-2">
                      {/* Whether or not to delete future recurrence */}
                      {hasRecurrence ? <Checkbox module="manager.schedule.CANCEL_MODAL" name="cancelFutureRecurrence" /> : null}
                      {/* Whether or not to send a cancellation email */}
                      {hasPublished ? <Checkbox module="manager.schedule.CANCEL_MODAL" name="sendCancellationEmails" /> : null}
                      {/* Comment to send to the employee */}
                      {values.sendCancellationEmails ? (
                        <Textarea module="manager.schedule.CANCEL_MODAL" name="cancellationComment" autoComplete="false" />
                      ) : null}
                    </Card.Body>
                  </Card>
                ) : null}
                <div className="mt-2">
                  <Button className="btn btn-primary mr-2" type="submit" isSubmitting={isSubmitting} text="actions.CONFIRM" />
                  <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
                    {t(`actions.CLOSE`)}
                  </Button>
                </div>
              </Form>
            )
          }}
        </Formik>
      )}
    </BaseModal>
  )
}

export default ScheduleUnassignEmployeeModal
